import app from 'flarum/common/app';

/** No forum e no admin: o atributo vem do ForumResource. */
export default function passwordless() {
  return !!app.forum?.attribute('magicLinkPasswordless');
}
flarum.reg.add('ramon-magic-link', 'common/passwordless', passwordless);